export default __webpack_public_path__ + "static/10_嘉宾头像_程鹏辉-cc39e457a777b6a964636d410c179cef.png";